var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantingBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "planting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "planting_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7527 15.4091C29.8456 14.0621 29.862 10.8472 27.7894 8.22842C25.7168 5.60962 22.3399 4.57859 20.247 5.92556C18.1541 7.27253 18.1377 10.4874 20.2103 13.1062C22.2829 15.725 25.6598 16.756 27.7527 15.4091Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9566 35.6076C35.4239 33.4379 34.5435 30.0641 31.99 28.072C29.4366 26.08 26.1771 26.224 24.7097 28.3937C23.2424 30.5634 24.1229 33.9372 26.6763 35.9293C29.2298 37.9213 32.4893 37.7773 33.9566 35.6076Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5436 18.8951C39.471 21.5139 39.4874 24.7288 41.5803 26.0757C43.6732 27.4227 47.0501 26.3917 49.1227 23.7729C51.1954 21.1541 51.1789 17.9392 49.086 16.5922C46.9931 15.2453 43.6162 16.2763 41.5436 18.8951Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 34.6673C5.05432 34.6673 2.6665 37.0551 2.6665 40.0007V61.334H61.3332V40.0007C61.3332 37.0551 58.9454 34.6673 55.9998 34.6673H50.0819C47.6125 34.6673 45.7192 36.3046 44.8476 38.1085C43.6513 40.5843 40.3721 45.334 31.9998 45.334C23.6276 45.334 20.3483 40.5843 19.1521 38.1085C18.2805 36.3046 16.3872 34.6673 13.9178 34.6673H7.99984ZM7.99984 56.0007V40.0007H13.9178C13.9178 40.0007 13.9272 40.0006 13.9464 40.0071C13.9677 40.0143 14.0047 40.0306 14.0531 40.0648C14.1566 40.1381 14.2707 40.2648 14.3499 40.4288C16.1248 44.102 20.9513 50.6673 31.9998 50.6673C43.0484 50.6673 47.8749 44.102 49.6498 40.4288C49.729 40.2648 49.8431 40.1381 49.9466 40.0648C49.9949 40.0306 50.0319 40.0143 50.0533 40.0071C50.0725 40.0006 50.0819 40.0007 50.0819 40.0007H55.9998V56.0007H7.99984Z",
    fill: "#0071CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantingBlue);
export default __webpack_public_path__ + "static/media/planting-blue.a43dc69e059db7311d467d2366fed18d.svg";
export { ForwardRef as ReactComponent };